import { IContainer } from '../interfaces/interfaces'

export const mockedData: IContainer[] = [
  {
    id: 14,
    status: 'CREATED',
    createdAt: '2025-07-01T11:07:40.599Z',
    updatedAt: '2025-07-01T11:07:40.599Z',
    operationNumber: 8,
    isReturned: false,
    totalItems: 0,
  },
  {
    id: 13,
    status: 'CREATED',
    createdAt: '2025-07-01T11:07:15.719Z',
    updatedAt: '2025-07-01T11:07:15.719Z',
    operationNumber: 7,
    isReturned: false,
    totalItems: 0,
  },
]
